/*
 * This only works on simple arrays. It will not work with arrays
 * that contain objects.
 */
export const arraysEqual = (a, b) => {
  return JSON.stringify(a.sort()) === JSON.stringify(b.sort())
}
